import { getModuleState as getEventInfoModuleState } from "../../selectors";
import { AgEventAPI } from "@ai360/core";
import { ScoutingTemplate } from "~/recs-events/events/model";
import { AgBytesItem, IObservationData, IPicklistOption } from "./models";

export const SCOUTING_STATE_KEY = "SCOUTING_STATE";

export const getModuleState = (state: unknown): Record<string, unknown> =>
    getEventInfoModuleState(state)[SCOUTING_STATE_KEY];

export const getObservationData = (state: unknown): IObservationData[] =>
    getModuleState(state).observationData as IObservationData[];

export const getGrowthStageData = (state: unknown): AgBytesItem[] =>
    getModuleState(state).growthStageData as AgBytesItem[];

export const getGrowthStageObservationData = (state: unknown): Map<string, IPicklistOption[]> =>
    getModuleState(state).growthStageObservationData as Map<string, IPicklistOption[]>;

export const getScoutingDataLoading = (state: unknown): boolean =>
    getModuleState(state).scoutingDataIsLoading as boolean;

export const getScoutingTemplate = (state: unknown): ScoutingTemplate =>
    getModuleState(state).scoutingTemplate as ScoutingTemplate;

export const getScoutingTemplateLoading = (state: unknown): boolean =>
    getModuleState(state).scoutingTemplateIsLoading as boolean;

export const getOriginalScoutingDetailList = (
    state: unknown
): Map<string, AgEventAPI.IScoutingDetail[]> =>
    getModuleState(state).originalScoutingDetailList as Map<string, AgEventAPI.IScoutingDetail[]>;
